import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { signOut } from "@/lib/auth";
import { getMessageFromError } from "@/lib/utils";
import { Link } from "react-router-dom";
import { toast } from "sonner";

const NotFoundPage = () => {
  const handleSignOut = async () => {
    try {
      await signOut();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      toast.error("Error al cerrar sesión", {
        description: getMessageFromError(error),
      });
    }
  };

  return (
    <div
      id="error-page"
      className="flex h-full flex-col bg-[#262452] text-center"
    >
      <Card className="m-auto max-w-md rounded-3xl p-4">
        <CardHeader>
          <CardTitle>Algo anda mal (Error 404)</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="mb-4 text-balance">
            La página que estás buscando no existe.
          </p>
          <p className="mt-6 flex gap-2">
            <Button variant={"secondary"} onClick={handleSignOut}>
              Cerrar sesión
            </Button>

            <Button asChild>
              <Link to="/">Volver a la página principal</Link>
            </Button>
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFoundPage;
